// import Logo from 'assets/svg/8thwall.svg'
import ErrorLogo from "assets/images/error-icon.png"

import {
  isIOS,
  isMobileSafari,
  isChrome,
  isFirefox,
  isEdge,
} from "react-device-detect"

export const customizeUI = () => {
  const loadImage = document.getElementById("loadImage")
  if (loadImage) {
    loadImage.src = ""
    loadImage.style.display = "none"
    loadImage.classList.remove("spin")
  }

  //powered by logo
  // const images = document.querySelectorAll('.poweredby-img')
  // for (let i = 0; i < images.length; i++) {
  //   images[i].src = Logo;
  //   images[i].style.width = '130px'
  // }

  //error
  const error = document.querySelector(
    "#cameraSelectionWorldTrackingError .floater"
  )
  error.src = ErrorLogo
}

export const customizePreview = () => {

  
  // document.querySelector("#requestingCameraPermissions").style.display = 'none'
  const errorContainers = [
    "#userPromptError",
    // "#cameraPermissionsErrorApple",
    // "#cameraPermissionsErrorAndroid",
    // "#microphonePermissionsErrorApple",
    // "#microphonePermissionsErrorAndroid",
    "#motionPermissionsErrorApple",
    "#deviceMotionErrorApple",
  ]
  errorContainers.forEach((name) => {
    const element = document.querySelector(name)

    element.innerHTML = `
    <div style="">
    <h2 style="margin-top: 50vw; margin-bottom: 30px; letter-spacing: -1px;">Ruh-ro!</h2>
    <p style=" width: 80%; margin: auto;">Looks like there's an issue accessing the motion sensors or camera on your device. Both are needed to enjoy this experience.</p>
    <div style="position: absolute; width: 100%; left: 0; right: 0; margin: auto; bottom: 50px;">
    <div style="display: flex; margin: auto; flex-direction: column; justify-content: center;">
      <a href="/experience" style="margin: auto; width: 65vw; font-weight: 900; background-color: white; color: black; text-decoration: none; padding: 18px 0;">Retry</a>
      <a href="/" style="margin: auto; width: 65vw; font-weight: 900; background-color: black; color: white; text-transform: uppercase; font-size: 13px; margin-top: 10px;">Exit</a>
    </div>
    </div>
    </div>
    `
  })


  const previewContainer = document.getElementById("previewContainer")
  const previewContainerStyles = {
    backgroundColor: "rgba(5, 20, 31, 0.6)",
    "backdrop-filter": "blur(10px)",
    "-webkit-backdrop-filter": "blur(10px)",
  }
  Object.assign(previewContainer.style, previewContainerStyles)

  const top = document.querySelector("#previewContainer .top-bar")
  const topBarStyles = {
    padding: "3rem 2rem 0.5rem",
    "user-select": "none",
    "-webkit-user-select": "none",
  }
  Object.assign(top.style, topBarStyles)

  const previewBoxStyles = {
    height: "100%",
    overflow: "hidden",
    width: "100%",
    position: "relative",
    marginTop: '-4vh',
  }
  
  Object.assign(top.querySelector(".preview-box").style, previewBoxStyles)

  const imageStyles = {
    border: "none",
    "border-radius": 0,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    "object-fit": "cover",
    "max-height": "unset",
    "max-width": "unset",
  }
  Object.assign(top.querySelector("#imagePreview").style, imageStyles)

  const bottom = document.querySelector("#previewContainer .bottom-bar")
  // bottom.remove()
  const bottomStyles = {
    width: "100%",
    margin: "auto",
    display: 'none',
  }
  Object.assign(bottom.style, bottomStyles)

  top.insertAdjacentHTML(
    "afterend",
    `
  <div id="customMessage" style="padding: 0 1rem 1rem;">
    <p style="font-size: 14px; margin-top: -10px; margin-bottom: 5px;">Press and hold image to save <br /> and share with <strong>#RoboDog</strong></p>
  </div>
  `
  )
  top.insertAdjacentHTML("beforebegin", `
  <h3 style="font-weight: 900; margin-top: 40px; margin-bottom: 0px; font-size: 24px;">So Cute!</h3>
  `)

  // ============= ADD IFRAME =============
  const iframeLocation = document.querySelector("#previewContainer .top-bar .preview-box")
  const url =
  process.env.NODE_ENV === "development"
    ? `https://${window.location.hostname}:3000/gestures`
    : `https://${window.location.hostname}/gestures`

    const iframeElement =  `              
    <iframe
      id="iframePhotoSave"
      style="width: 200px; height: 350px; transform: scale(0.7); opacity: 0; pointer-events: none;"
      style="visibility:hidden;" 
      title="press and hold"
      src="${url}/ShareSave.html"
      scrolling="no"
      frameborder="0"
  ></iframe>`

  iframeLocation.insertAdjacentHTML(
    "afterend",
    ` 
      <div id="iframePhotoSaveContainer" style="position: absolute; z-index: 999; right: 20px; bottom: -45px; pointer-events: none;">
        ${iframeElement}
      </div>
    `
  )
  // ============= ADD IFRAME =============

  // ============= RESTYLE BUTTON =============
  const close = document.querySelector('#closePreviewButton')
  close.innerHTML = `<div style="display: flex; align-items: center;">
  <div style="font-size: 38px; margin-right: 8px; scaleY(0.8)">&#60;</div> 
  <div style="font-size: 16px; margin-top: 5px; font-weight: 900;">Back</div>
  </div>`
  close.style.color = 'white'
  close.remove()
  const previewBox = document.querySelector('#previewContainer .top-bar')
  previewBox.insertAdjacentHTML(
    "beforebegin",
    `<div id="backBtnCustom" style="position: absolute; left: 93px; top: -20px; text-decoration: none; color: white; "></div>`
  )
  document.getElementById('backBtnCustom').appendChild(close)
  // ============= RESTYLE BUTTON =============


  if (isIOS && isMobileSafari && !isChrome && !isFirefox && !isEdge) {
    // // ADD SHARE BUTTON
    const shareBtn = document.querySelector("#actionButton")
    shareBtn.style.display = 'none'
  }

  window.addEventListener("realityerror", (event) => {
    console.error("ERROR")
  })
}

export const toggleRecordButton = (enable = false) => {
  const el = document.getElementById("recorder")
  if (el) {
    if (enable) {
      el.classList.add("enable")
    } else {
      el.classList.remove("enable")
    }
  }
}
